import { HTTPError } from "src/contexts/_shared/domain/errors/HTTPError";
import { DocumentationAreaUnavailableReason } from "src/apps/routes/DocumentationAreaUnavailableScreen";

const REMOVAL_REASONS: string[] = Object.values(DocumentationAreaUnavailableReason);

// Returns the removal code when the error is a 404 saying the actor or the user access was removed
export const getDocumentationAreaRemovalReason = (error: unknown) => {
  if (!(error instanceof HTTPError) || !error.getHTTPCode().isNotFound()) {
    return undefined;
  }
  const code = error.getCode();
  return code && REMOVAL_REASONS.includes(code) ? code : undefined;
};

// Regenerated on every page load. History state survives a refresh, this id does not
const PAGE_LOAD_ID = Math.random().toString(36).slice(2);

export const getUnavailableLocationState = (reason?: string) => ({
  reason,
  pageLoadId: PAGE_LOAD_ID,
});

export const isUnavailableStateFromCurrentPageLoad = (state: { pageLoadId?: string } | null) =>
  state?.pageLoadId === PAGE_LOAD_ID;
